import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Dropdown,
  Option,
  TextArea,
  Reporte,
  Custom
} from '@app/shared';
import { find } from 'rxjs/operators';


@Injectable()
export class ReportsFormService {

  table = false;

  constructor() { }

  /**
   * Retorna el formulario de guardar o editar un reporte
   *
   * @param {Option[]} typesReports
   * @param {Reporte} [datValue]
   * @returns {BaseControl<any>[]}
   * @memberof ReportsFormService
   */
  getForm(typesReports: Option[], datValue?: Reporte, template?: any, typeReport?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtNombre',
        label: 'Nombre del reporte',
        value: datValue ? datValue.nombre : '',
        order: 1,
        placeholder: 'Ingrese el nombre del reporte',
        validations: {
          validators: [Validators.required],
        }
      }),
      new TextArea({
        key: 'txtDescripcion',
        label: 'Descripción:',
        value: datValue ? datValue.descripcion : '',
        order: 2,
        placeholder: 'Ingrese una descripción para el reporte',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtCodigo',
        label: 'Código:',
        value: datValue ? datValue.codigo : '',
        order: 3,
        placeholder: 'Ingrese el código del reporte',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Dropdown({
        key: 'cboTipoReporte',
        label: 'Tipo de reporte:',
        value: datValue ?
                datValue.tipo_reporte ?
                  (typeof datValue.tipo_reporte === 'number') ?
                    datValue.tipo_reporte
                  : (datValue.tipo_reporte.id) ?
                    datValue.tipo_reporte.id
                  : null
                : null
              : null,
        options: typesReports,
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'plantilla',
        label: 'Plantilla',
        order: 5,
        template: template,
      }),
      new TextArea({
        key: 'txtQuery',
        label: 'Query:',
        value: datValue ? datValue.query : '',
        order: 6,
        rows: '8',
        placeholder: 'Ingrese la query del reporte',
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoReporte',
            siEs: 'Igual',
            valor: typeReport,
            accion: 'Mostrar',
          }
        ]
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/shared/reports.form.service.ts